import { useContext } from "react";
import { AmplitudeContext } from "./AmplitudeContext.js";
function useAmplitude() {
    const context = useContext(AmplitudeContext);
    if (void 0 === context) throw new Error('useAmplitude must be used within an AmplitudeProvider');
    return context;
}
const Amplitude_useAmplitude = useAmplitude;
export default Amplitude_useAmplitude;
